var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Media Library") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-180.000000, -31.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Draft",
    transform: "translate(180.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,0.5 L18.5,19.95762 L4.81066323,19.95762 L4.81066323,0.5 L18.5,0.5 Z M18.3126713,0.742466191 L4.99640991,0.742466191 L4.99640991,19.7151538 L18.3126713,19.7151538 L18.3126713,0.742466191 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B7844D",
    x: 0.5,
    y: 0.517445649,
    width: 1.57063393,
    height: 16.3579806
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.76620409,18.8963029 L1.28531697,19.8704474 L0.804429849,18.8963029 L1.76620409,18.8963029 Z",
    id: "Path-2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaLibrary);
export default __webpack_public_path__ + "static/media/Media Library.7e2bde7c155ea1dcc6d02be069c145a9.svg";
export { ForwardRef as ReactComponent };